import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../public/fonts/averta-semibold-webfont.woff2%22,%22weight%22:%22600%22,%22style%22:%22bold%22,%22variable%22:%22--font-averta-semibold%22}],%22variableName%22:%22avertaSemibold%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'avertaSemibold', 'avertaSemibold Fallback'",
        fontWeight: 600,
fontStyle: "bold",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
